

















































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import Dialog from '@/components/Dialog.vue';
import { AUTH_REQUEST } from '@/store/auth';
import { ErrorHandler, FormError } from '@/modules/FormError';
import { WORK } from '@/router/work';

@Component({
  components: { Dialog }
})
export default class LogIn extends Vue implements FormError {
  @Prop() private showDialog!: boolean;
  public form = {
    username: '',
    password: ''
  };
  public showPassword:boolean = false;
  public errorMessage:string = '';
  public loading: boolean = false;

  public $refs!: {
    login: HTMLFormElement
  };

  @Watch('form', { immediate: true, deep: true })
  onFormChanged () {
    this.errorMessage = '';
  }

  login () {
    this.loading = true;
    this.$store.dispatch(AUTH_REQUEST, this.form).then(() => {
      this.$emit('close');
      this.$router.push({ name: WORK });
    }).catch(e => new ErrorHandler(this, e));
  }

  setErrors (data: any): void {
    this.$refs.login.setErrors(data);
  }
}
